export const SIDEBAR_LIST = {
	GENERAL_SETTINGS: {
		SETTING_NAME: 'GENERAL_SETTINGS',
		LABEL: 'General Settings'
	},
	SCRIPTS_SETTINGS: {
		SETTING_NAME: 'SCRIPTS_SETTINGS',
		LABEL: 'Scripts'
	},
	SPLIT_CONFIGS_SETTINGS: {
		SETTING_NAME: 'SPLIT_CONFIGS_SETTINGS',
		LABEL: 'Split Configurations'
	}
};

export const EDIT_MODES = {
	CREATE: 'SPLIT_DOC_CREATE',
	UPDATE: 'SPLIT_DOC_UPDATE'
};

export const TAB_CONSTANTS = {
	GENERAL: 'GENERAL',
	SCRIPTS: 'SCRIPTS',
	SPLIT_CONFIGURATIONS: 'SPLIT_CONFIGURATIONS'
};

export const SCRIPT_TYPES = {
	URL: 'URL',
	SCRIPT: 'SCRIPT',
	HTML: 'HTML'
};
